"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.urlParam = urlParam;
exports.parseCmsVars = parseCmsVars;
exports.kebabCase = kebabCase;
exports.snakeCase = snakeCase;
exports.camelCase = camelCase;
exports.firstLetterUpperCase = firstLetterUpperCase;
exports.createGuid = createGuid;
exports.gaTrackingEvent = gaTrackingEvent;
exports.currencyToFloat = currencyToFloat;

var _StringUtils = _interopRequireDefault(require("./StringUtils"));

var _UrlUtils = _interopRequireDefault(require("./UrlUtils"));

var _ObjectUtils = _interopRequireDefault(require("./ObjectUtils"));

var _CurrencyUtils = _interopRequireDefault(require("./CurrencyUtils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @deprecated Please use UrlUtils
 */
function urlParam(url, param) {
  return _UrlUtils.default.getParam(url, param);
} // String Formatting

/**
 * @deprecated please use StringUtils
 */


function parseCmsVars(source, pairs) {
  return _StringUtils.default.parseCmsVars(source, pairs);
}
/**
 * @deprecated Please use StringUtils
 */


function kebabCase(input) {
  return _StringUtils.default.kebabCase(input);
}
/**
 * @deprecated Please use StringUtils
 */


function snakeCase(input) {
  return _StringUtils.default.snakeCase(input);
}
/**
 * @deprecated Please use StringUtils
 */


function camelCase(input) {
  return _StringUtils.default.camelCase(input);
}
/**
 * @deprecated Please use StringUtils
 */


function firstLetterUpperCase(input) {
  return _StringUtils.default.firstLetterUpperCase(input);
}
/**
 * @deprecated Please use StringUtils
 */


function createGuid() {
  return _StringUtils.default.createGuid();
}
/**
 * @deprecated Please use ObjectUtils
 */


function gaTrackingEvent(eventData) {
  _ObjectUtils.default.gaTrackingEvent(eventData);
}
/**
 * @deprecated Please use CurrencyUtils
 */


function currencyToFloat(value) {
  return _CurrencyUtils.default.currencyToFloat(value);
}
//# sourceMappingURL=Utils.js.map